<!-- row -->
<div class="row">

  <!-- Page Content -->
  <div class="col-12 content-page">

  </div>
  <!-- //Page Content -->

</div>
<!-- //.row -->



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor.component.html